import type { GetRequestsListItem } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../../types/tables";

import { TABLE_LAYOUT_PRESETS } from "../../../constants/columnWidths";
import { accountTagsCell } from "../../../helpers/accountTagsCell";
import {
  accountCell,
  brandCell,
  complexityCell,
  designTypeCell,
  nameCell,
} from "../../../helpers/commonCells";

// Designer Assigned to Me - Ready for Review Section Configuration
// Columns: Name, Account, Complexity, Brand, Design Type, Tags
export const designerAssignedToMeReadyForReviewTableConfig: TableConfig<GetRequestsListItem> =
  {
    columns: [
      {
        accessor: "name",
        cellRenderer: nameCell,
        header: "Name",
        key: "name",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.name,
      },
      {
        accessor: "account",
        cellRenderer: accountCell,
        header: "Account",
        key: "account",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.account,
      },
      {
        accessor: "complexity",
        cellRenderer: complexityCell,
        header: "Complexity",
        key: "complexity",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.complexity,
      },
      {
        accessor: "brand",
        cellRenderer: brandCell,
        header: "Brand",
        key: "brand",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.brand,
      },
      {
        accessor: "designType",
        cellRenderer: designTypeCell,
        header: "Design Type",
        key: "designType",
        sortable: true,
        width: TABLE_LAYOUT_PRESETS.superadmin.requestType,
      },
      {
        accessor: "account",
        cellRenderer: accountTagsCell,
        header: "Tags",
        key: "accountTags",
        sortable: false,
        width: 150,
      },
    ],
    defaultSort: {
      column: "createdAt",
      direction: "desc",
    },
    getRowClassName: whitelabelRowClassName,
    id: "designer-assigned-to-me-ready-for-review",
  };
